import React from "react";
import { LucideProps } from "lucide-react";
import {
  Check,
  CheckCheck,
  X,
  Plus,
  Trash2,
  Edit,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  LayoutDashboard,
  Settings,
  CreditCard,
  Users,
  Send,
  Info,
  Menu,
  CheckCircleIcon,
  XCircleIcon,
  LockOpenIcon,
  ChartBarIcon,
  Bell,
  TriangleAlert,
  OctagonAlert,
  CircleHelp,
  LogIn,
  Download,
  UserRoundPlus,
  BellRing,
  Phone,
  CalendarRange,
  Workflow,
  Copy,
} from "lucide-react";
import clsx from "clsx";

// Create a mapping of icon names to their corresponding components
const iconMap: Record<string, React.FC<LucideProps>> = {
  check: Check,
  x: X,
  plus: Plus,
  trash: Trash2,
  edit: Edit,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronDown: ChevronDown,
  dashboard: LayoutDashboard,
  settings: Settings,
  card: CreditCard,
  users: Users,
  send: Send,
  info: Info,
  help: CircleHelp,
  menu: Menu,
  checkCircle: CheckCircleIcon,
  xCircle: XCircleIcon,
  lockOpen: LockOpenIcon,
  chartBar: ChartBarIcon,
  bell: Bell,
  warning: TriangleAlert,
  danger: OctagonAlert,
  checkCheck: CheckCheck,
  login: LogIn,
  download: Download,
  addUser: UserRoundPlus,
  bellRing: BellRing,
  phone: Phone,
  report: CalendarRange,
  integration: Workflow,
  copy: Copy,
};

interface AppIconProps extends Omit<LucideProps, "ref"> {
  name: string; // The name of the icon (must match keys in `iconMap`)
  className?: string;
  size?: "sm" | "md" | "lg" | number; // Accept string values or custom number for size
}

const AppIcon: React.FC<AppIconProps> = ({ name, className = "", size = "md", ...props }) => {
  const IconComponent = iconMap[name]; // Get the icon component from the map

  if (!IconComponent) {
    console.error(`Icon "${name}" not found in the icon map.`);
    return null; // Return null or a fallback UI if the icon is not found
  }

  const dynamicSize = typeof size === "number" ? `${size}px` : undefined;

  return (
    <IconComponent
      className={clsx(
        "transition duration-300 ease-in-out",
        {
          "w-3 h-3": size === "sm",
          "w-5 h-5": size === "md",
          "w-6 h-6": size === "lg",
        },
        className
      )}
      style={dynamicSize ? { width: dynamicSize, height: dynamicSize } : undefined}
      {...props}
    />
  );
};

export default AppIcon;